import schedulingPopup from './scheduling-popup/scheduling-popup';
import stampit from 'stampit';

const componentName = 'scheduling';
const serviceName = 'SchedulingRealtimeComponent';
const moduleName = 'doxy.realtime.components.scheduling';

export { componentName, serviceName, moduleName };

export default angular
  .module(moduleName, [schedulingPopup])
  .factory('SchedulingRealtimeComponent', function (schedulingPopup) {
    return stampit({
      deepProps: {
        componentName,
        name: 'Scheduling',
      },
      methods: {
        open({ peopleAvailable, user }) {
          schedulingPopup.open({ peopleAvailable, user });
        },
      },
    });
  }).name;
